const DashboardIcon = (): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='w-4 h-4'
      viewBox='0 0 24 24'
      fill='none'
      height='100%'
      width='100%'
    >
      <rect x='2' y='2' width='9' height='9' rx='2' fill='currentColor'></rect>
      <rect opacity='0.5' x='13' y='2' width='9' height='9' rx='2' fill='currentColor'></rect>
      <rect opacity='0.5' x='13' y='13' width='9' height='9' rx='2' fill='currentColor'></rect>
      <rect opacity='0.5' x='2' y='13' width='9' height='9' rx='2' fill='currentColor'></rect>
    </svg>
  )
}

export default DashboardIcon
